import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { EventToolbox } from 'client/utils/event-toolbox';
import { PAGE_CONTENT_UPDATE } from 'client/tracking/constant';
import { usePrevious } from 'client/site-modules/shared/hooks/use-previous';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  DESKTOP_IMAGE_WIDTH,
  LEASE_DEALS_CARD_LIST_ANCHOR,
  MOBILE_IMAGE_WIDTH,
} from 'client/site-modules/lease-deals/constants/lease-deals-constants';
import { LeaseDealsEntities } from 'site-modules/lease-deals/constants/prop-types';
import { LeaseDealsGridViewCardList } from 'site-modules/lease-deals/components/lease-deals-grid-view-card-list/lease-deals-grid-view-card-list';
import { LeaseDealsListViewCardList } from 'site-modules/lease-deals/components/lease-deals-list-view-card-list/lease-deals-list-view-card-list';
import { LeaseDealsPagination } from 'site-modules/lease-deals/components/lease-deals-pagination/lease-deals-pagination';
import { usePersistedData } from 'site-modules/lease-deals/hooks/use-persisted-data/use-persisted-data';
import { LowInventoryScreen } from 'site-modules/lease-deals/components/low-inventory-screen/low-inventory-screen';

const CARD_LISTS_MAP = {
  grid: LeaseDealsGridViewCardList,
  list: LeaseDealsListViewCardList,
};

export const LeaseDealsCardListUI = memo(
  ({
    type,
    photos: photosProp = undefined,
    setModelValue,
    dealsCount = 0,
    isShop4931ZeroDownRoute = false,
    isMobile = false,
    ...restProps
  }) => {
    const CardListComponent = CARD_LISTS_MAP[type];

    const previousType = usePrevious(type);

    const [photos] = usePersistedData(photosProp);

    useEffect(() => {
      if (type !== previousType) {
        EventToolbox.fireCustomEvent(PAGE_CONTENT_UPDATE);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    return (
      <div id={LEASE_DEALS_CARD_LIST_ANCHOR}>
        <CardListComponent
          isMobile={isMobile}
          {...restProps}
          photos={photos}
          isShop4931ZeroDownRoute={isShop4931ZeroDownRoute}
        />
        {dealsCount <= 6 && <LowInventoryScreen dealsCount={dealsCount} />}
        <LeaseDealsPagination isMobile={isMobile} />
      </div>
    );
  }
);

LeaseDealsCardListUI.propTypes = {
  isMobile: PropTypes.bool,
  deals: LeaseDealsEntities.Deals.isRequired,
  photos: PropTypes.arrayOf(PropTypes.shape({})),
  type: PropTypes.string.isRequired,
  dealsCount: PropTypes.number,
  isShop4931ZeroDownRoute: PropTypes.bool,
};

LeaseDealsCardListUI.displayName = 'LeaseDealsCardListUI';

export const stateToPropsConfig = {
  photos: bindToPath(
    ({ isMobile }) => LeaseDealsPaths.getPhotosPath(isMobile ? MOBILE_IMAGE_WIDTH : DESKTOP_IMAGE_WIDTH),
    LeaseDealsModel,
    null,
    false
  ),
};

export const LeaseDealsCardList = connectToModel(LeaseDealsCardListUI, stateToPropsConfig);
